import { useParams } from "react-router-dom";
import { PostDetail } from "@/components/features/PostDetail";

export function PostDetailPage() {
  const { postId } = useParams<{ postId: string }>();
  if (!postId) return null;
  return <PostDetail postId={postId} />;
}
